import React, { useCallback, useEffect } from 'react';
import { DefaultQueryParams, MainWr, parseQuery } from '@pascal/pascal-core';
import { useLocation } from 'react-router-dom';
import { Factory } from './components/factory';
import Loading from './components/loading';
import { ComboKeno8GameId } from './core/constants/appDefaultValues';
import { applicationStore } from './store/applicationStore';
import { Space } from './core/constants/defaultConstants';

function App() {
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);

  useEffect(() => {
    applicationStore.setIsKeno8(+gameId === ComboKeno8GameId);
  }, [gameId]);

  const handleKeyDown = useCallback((e) => {
    if (e.code === Space) {
      e.preventDefault();
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <Loading>
      <MainWr>
        <Factory />
      </MainWr>
    </Loading>
  );
}

export default App;
